import { FormControl, FormControlLabel, Radio, TextField } from "@mui/material";
import styled  from "styled-components";

export const InputStyles = styled(TextField)`
    .MuiInputBase-root{
        background-color: #e7e7e7;
        border-radius: 10px;
        &::before{
            border-bottom: 1px solid ${p => p.theme.secondColor} !important;;
        }
        &::after{
            border-bottom: 2px solid ${p => p.theme.secondColor} !important;;
        }
        &:focus{
            border-bottom: 3px solid ${p => p.theme.secondColor} !important;; 
        }

        .MuiInputAdornment-positionEnd {
            padding-right: 6px !important;
        }
        
    }
    .MuiFormLabel-root{
        z-index: 1;
        padding-left: 3px;
    }
    .MuiInputLabel-root.Mui-focused{
            color:${p => p.theme.primaryFontColor} !important;; 
    }
    .MuiInputBase-input {
        margin-left: 5px !important;
    }
    
`

export const SelectStyle = styled(FormControl)`
    .MuiInputBase-root{
        background-color: #e7e7e7;
        border-radius: 10px;
        &::before{
            border-bottom: 1px solid ${p => p.theme.secondColor} !important;
        }
        &::after{
            border-bottom: 2px solid ${p => p.theme.secondColor} !important;
        }
        &:focus{
            border-bottom: 3px solid ${p => p.theme.secondColor} !important;
        }
        
    }
    .MuiFormLabel-root{
        z-index: 1;
        padding-left: 3px;
    }
    .MuiInputLabel-root.Mui-focused{
        color: ${p => p.theme.primaryFontColor} !important; 
    }
    .MuiInputBase-input {
        margin-left: 5px !important;
    }
`


export const RadioContainer = styled(FormControl)`
    width: 100%;
`;

export const RadioButtonS = styled(FormControlLabel)`
    .MuiRadio-root {
        color: ${p => p.theme.primaryFontcolor} !important;
    }

    .MuiRadio-root.Mui-checked {
        color: ${p => p.theme.secondColor} !important;
    }
`